module.exports = "/images/calendar-search.svg?6cff5b8868ae9758b0c57a31feefd66a";